import { Stack, Text, Tooltip } from '@mantine/core';

type LabelTableCellPropsType = {
  label: string;
  internalNote: string | null;
};

export const LabelTableCell: React.FC<LabelTableCellPropsType> = ({
  label,
  internalNote,
}) => (
  <Stack gap={0}>
    <Text size="sm">{label}</Text>
    {internalNote && (
      <Tooltip label={internalNote} multiline maw={300}>
        <Text size="xs" c="dimmed" lineClamp={1}>
          {internalNote}
        </Text>
      </Tooltip>
    )}
  </Stack>
);
